import axios from 'Axios';

export const getTicketsByProjects = (
  searchTerm = '',
  sort = '',
  order = ''
) => {
  return axios.get(
    `/supply/projects?searchRefName=${searchTerm}&sort=${sort}&order=${order}`
  );
};
export const getQueriesByCity = (searchTerm = '', sort = '', order = '') => {
  return axios.get(
    `/supply/queries?searchRefName=${searchTerm}&sort=${sort}&order=${order}`
  );
};

export const getHidenTickets = () => {
  return axios.get('/supply/ticket/hidden');
};
